(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sizing-ai-prompt"] && !Shopify.designMode) return;
  try {
    (function () {
    var REC_REGEX = /<!--RECOMMENDATION-->\s*([\s\S]*?)\s*<!--\/RECOMMENDATION-->/;

    function parseRecommendation(reply) {
      var match = reply.match(REC_REGEX);
      var prose = reply.replace(REC_REGEX, '').replace(/\n{3,}/g, '\n\n').trim();
      if (!match) return { recommendation: null, prose: prose };
      try {
        var parsed = JSON.parse(match[1]);
        if (!parsed || !parsed.variant_id || !parsed.size || !parsed.confidence) {
          return { recommendation: null, prose: prose };
        }
        return { recommendation: parsed, prose: prose };
      } catch (e) {
        return { recommendation: null, prose: prose };
      }
    }

    function stripPartialRec(text) {
      var openIdx = text.indexOf('<!--RECOMMENDATION-->');
      if (openIdx === -1) return text;
      var closeIdx = text.indexOf('<!--/RECOMMENDATION-->', openIdx);
      if (closeIdx === -1) return text.slice(0, openIdx).replace(/\n+$/, '');
      return (text.slice(0, openIdx) + text.slice(closeIdx + '<!--/RECOMMENDATION-->'.length)).replace(/\n{3,}/g, '\n\n').trim();
    }

    function inferRecommendationFromProse(prose, variants) {
      var text = String(prose || '').toLowerCase();
      if (!text || !variants || !variants.length) return null;

      var candidates = variants.slice().sort(function (a, b) {
        return String(b.size || '').length - String(a.size || '').length;
      });

      for (var i = 0; i < candidates.length; i++) {
        var variant = candidates[i];
        var size = String(variant.size || '').trim();
        if (!size || !variant.id) continue;

        var normalizedSize = size.toLowerCase().replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
        var pattern = new RegExp('(^|[^a-z])' + normalizedSize + '([^a-z]|$)', 'i');
        if (!pattern.test(text)) continue;

        return {
          variant_id: String(variant.id),
          size: size,
          confidence: 'inferred_from_prose'
        };
      }

      return null;
    }

    function normalizeSizeName(name) {
      var n = String(name || '').toLowerCase().trim().replace(/[\s\-_]+/g, ' ');
      var map = {
        'extra small': 'xs', 'xs': 'xs',
        'small': 's', 's': 's',
        'medium': 'm', 'm': 'm',
        'large': 'l', 'l': 'l',
        'extra large': 'xl', 'xl': 'xl',
        'wide medium': 'widem', 'wide m': 'widem',
        'wide large': 'widel', 'wide l': 'widel',
        'wide extra large': 'widexl', 'wide xl': 'widexl'
      };
      return map[n] || n;
    }

    function extractBoldedSize(proseText) {
      var matches = String(proseText || '').match(/\*\*([^*]+)\*\*/g);
      if (!matches) return null;
      var validKeys = { xs:1, s:1, m:1, l:1, xl:1, widem:1, widel:1, widexl:1 };
      for (var i = matches.length - 1; i >= 0; i--) {
        var inner = matches[i].slice(2, -2).trim();
        var normalized = normalizeSizeName(inner);
        if (validKeys[normalized]) return normalized;
      }
      return null;
    }

    function reportSizingAiIntegrity(recId, mismatch) {
      if (!recId) return;
      var url = 'https://apolla-hq.vercel.app/api/sizing-ai-report/';
      var payload = JSON.stringify({
        rec_id: recId,
        was_prose_json_mismatch: !!mismatch
      });

      try {
        if (navigator.sendBeacon) {
          var blob = new Blob([payload], { type: 'application/json' });
          if (navigator.sendBeacon(url, blob)) return;
        }
      } catch (beaconErr) { /* fall through to fetch */ }

      try {
        fetch(url, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: payload,
          keepalive: true
        }).catch(function () { /* best-effort */ });
      } catch (fetchErr) { /* swallow */ }
    }

    function escapeHtml(s) {
      return String(s).replace(/[&<>"']/g, function (c) {
        return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
      });
    }

    function init(root) {
      if (root.dataset.initialized === 'true') return;
      root.dataset.initialized = 'true';

      var trigger = root.querySelector('.apolla-sizing-ai__trigger');
      var panel = root.querySelector('.apolla-sizing-ai__panel');
      var form = root.querySelector('.apolla-sizing-ai__form');
      var loading = root.querySelector('.apolla-sizing-ai__loading');
      var answer = root.querySelector('.apolla-sizing-ai__answer');
      var prose = root.querySelector('.apolla-sizing-ai__answer-prose');
      var ctaSlot = root.querySelector('.apolla-sizing-ai__answer-cta');
      var restart = root.querySelector('.apolla-sizing-ai__restart');
      var errorBox = root.querySelector('.apolla-sizing-ai__error');
      var errorMsg = root.querySelector('.apolla-sizing-ai__error-msg');
      var submit = form.querySelector('.apolla-sizing-ai__submit');

      if (!trigger || !panel || !form) return;

      var endpoint = root.dataset.endpoint;
      var productHandle = root.dataset.productHandle;
      var productId = root.dataset.productId;
      var icpHint = root.dataset.icpHint || '';
      var productScope = root.closest('product-info') || document;

      var variantsCache = null;

      function togglePanel(open) {
        trigger.setAttribute('aria-expanded', String(open));
        if (open) panel.removeAttribute('hidden');
        else panel.setAttribute('hidden', '');
      }

      function showState(name) {
        form.style.display = (name === 'form') ? '' : 'none';
        if (name === 'loading') loading.removeAttribute('hidden');
        else loading.setAttribute('hidden', '');
        if (name === 'answer') answer.removeAttribute('hidden');
        else answer.setAttribute('hidden', '');
        if (name === 'error') errorBox.removeAttribute('hidden');
        else errorBox.setAttribute('hidden', '');
      }

      function showError(message) {
        errorMsg.textContent = message || 'Our sizing assistant is offline. Please try the size chart.';
        showState('error');
      }

      function resetForm() {
        prose.textContent = '';
        ctaSlot.innerHTML = '';
        ctaSlot.setAttribute('hidden', '');
        showState('form');
      }

      async function fetchVariants() {
        if (variantsCache) return variantsCache;
        var res = await fetch('/products/' + productHandle + '.js');
        if (!res.ok) throw new Error('Could not load product variants');
        var data = await res.json();
        var rawVariants = data.variants || [];
        var options = data.options || [];

        var sizeIdx = 0;
        var colorIdx = 0;
        for (var i = 0; i < options.length; i++) {
          var name = String(options[i].name || '').toLowerCase();
          if (name === 'size') sizeIdx = i + 1;
          if (name === 'color') colorIdx = i + 1;
        }

        var currentVariant = null;
        try {
          var scopedVariantInput = productScope.querySelector('form[action*="/cart/add"] input[name="id"]');
          var scopedVariantId = scopedVariantInput && scopedVariantInput.value;
          if (!scopedVariantId) {
            var params = new URLSearchParams(window.location.search);
            scopedVariantId = params.get('variant');
          }
          if (scopedVariantId) {
            currentVariant = rawVariants.filter(function (v) { return String(v.id) === scopedVariantId; })[0];
          }
        } catch (e) {}
        if (!currentVariant && rawVariants.length) currentVariant = rawVariants[0];

        function score(v) {
          var s = 0;
          if (v.available) s += 10;
          if (currentVariant) {
            for (var k = 1; k <= 3; k++) {
              if (k === sizeIdx) continue;
              if (v['option' + k] && v['option' + k] === currentVariant['option' + k]) s += 1;
            }
          }
          return s;
        }

        var bySize = {};
        for (var j = 0; j < rawVariants.length; j++) {
          var v = rawVariants[j];
          var sizeKey = sizeIdx > 0 ? (v['option' + sizeIdx] || v.title) : v.title;
          if (!sizeKey) continue;
          if (!bySize[sizeKey] || score(v) > score(bySize[sizeKey])) {
            bySize[sizeKey] = v;
          }
        }

        var SIZE_ORDER = {
          'extra small': 1, 'xs': 1,
          'small': 2, 's': 2,
          'medium': 3, 'm': 3,
          'large': 4, 'l': 4,
          'extra large': 5, 'xl': 5,
          'wide medium': 6, 'wide m': 6,
          'wide large': 7, 'wide l': 7,
          'wide extra large': 8, 'wide xl': 8
        };
        var keys = Object.keys(bySize).sort(function (a, b) {
          var oa = SIZE_ORDER[String(a).toLowerCase()] || 99;
          var ob = SIZE_ORDER[String(b).toLowerCase()] || 99;
          return oa - ob;
        });

        variantsCache = keys.map(function (sizeKey) {
          var v = bySize[sizeKey];
          return {
            id: String(v.id),
            title: v.title || '',
            size: sizeKey,
            color: colorIdx > 0 ? v['option' + colorIdx] : (v.option2 || undefined),
            available: !!v.available,
            price: ((v.price || 0) / 100).toFixed(2)
          };
        });
        return variantsCache;
      }

      function collectAnswers() {
        var fd = new FormData(form);
        var answers = {};
        var shoe = (fd.get('shoe_size') || '').toString().trim();
        var gender = (fd.get('shoe_size_gender') || '').toString().trim();
        var width = (fd.get('foot_width') || '').toString().trim();
        if (shoe) answers.shoe_size = shoe;
        if (gender) answers.shoe_size_gender = gender;
        if (width) answers.foot_width = width;
        var freetext = (fd.get('freetext') || '').toString().trim();
        return { structured_answers: answers, freetext: freetext };
      }

      async function submitForm(e) {
        e.preventDefault();
        showState('loading');
        if (!form.checkValidity()) {
          form.reportValidity();
          return;
        }
        submit.disabled = true;

        var variants;
        try {
          variants = await fetchVariants();
        } catch (err) {
          showError('Could not load product info. Try refreshing the page.');
          submit.disabled = false;
          return;
        }

        var answers = collectAnswers();

        // Phase A5 — monitoring identifiers
        var SESSION_KEY = 'apolla_sizing_session';
        var SESSION_TS_KEY = 'apolla_sizing_session_ts';
        var SESSION_TTL_MS = 30 * 24 * 60 * 60 * 1000;
        var sessionUuid;
        try {
          var existingSid = localStorage.getItem(SESSION_KEY);
          var sidTs = parseInt(localStorage.getItem(SESSION_TS_KEY) || '0', 10);
          if (existingSid && sidTs && (Date.now() - sidTs) < SESSION_TTL_MS) {
            sessionUuid = existingSid;
          } else {
            sessionUuid = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('sess-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10));
            localStorage.setItem(SESSION_KEY, sessionUuid);
            localStorage.setItem(SESSION_TS_KEY, String(Date.now()));
          }
        } catch (lsErr) {
          sessionUuid = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('rec-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10));
        }
        var recId = (window.crypto && window.crypto.randomUUID) ? window.crypto.randomUUID() : ('rec-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10));
        var promptVersion = null;

        var body = {
          product_handle: productHandle,
          product_id: productId,
          available_variants: variants,
          structured_answers: answers.structured_answers,
          freetext: answers.freetext || undefined,
          rec_id: recId,
          session_uuid: sessionUuid,
          widget_source: 'pdp'
        };
        if (icpHint) body.icp_hint = icpHint;

        showState('answer');
        prose.textContent = '';

        var fullText = '';
        var recommendation = null;

        // Silence detector: if no bytes arrive for SILENCE_MS, abort the fetch
        // and route the customer to live chat. Timer is killed permanently on the
        // first SSE chunk — once Anthropic is proven alive the response can take
        // as long as it needs. Mirrors size-charts widget; outage signature was
        // observed 2026-05-13 (Anthropic overload event).
        var SILENCE_MS = 10000;
        var ac = (typeof AbortController === 'function') ? new AbortController() : null;
        var silentTimeout = false;
        var silenceTimer = null;
        function armSilenceTimer() {
          if (silenceTimer) clearTimeout(silenceTimer);
          if (!ac) return;
          silenceTimer = setTimeout(function () {
            silentTimeout = true;
            try { ac.abort(); } catch (e) { /* swallow */ }
          }, SILENCE_MS);
        }
        function clearSilenceTimer() {
          if (silenceTimer) { clearTimeout(silenceTimer); silenceTimer = null; }
        }
        armSilenceTimer();

        try {
          var res = await fetch(endpoint, {
            method: 'POST',
            headers: {
              'content-type': 'application/json',
              'X-Rec-ID': recId,
              'X-Session-UUID': sessionUuid
            },
            body: JSON.stringify(body),
            signal: ac ? ac.signal : undefined
          });

          if (!res.ok || !res.body) {
            clearSilenceTimer();
            showError('Sizing AI returned ' + res.status + '. Try the size chart for now.');
            submit.disabled = false;
            return;
          }

          var reader = res.body.getReader();
          var decoder = new TextDecoder();
          var buffer = '';

          while (true) {
            var chunk = await reader.read();
            if (chunk.done) break;
            // First byte = Anthropic alive. Kill the silence timer permanently.
            clearSilenceTimer();
            buffer += decoder.decode(chunk.value, { stream: true });
            var events = buffer.split('\n\n');
            buffer = events.pop();
            for (var i = 0; i < events.length; i++) {
              var line = events[i];
              if (!line.startsWith('data: ')) continue;
              var payload;
              try { payload = JSON.parse(line.slice(6)); } catch (_) { continue; }
              if (payload.type === 'token') {
                fullText += payload.text;
                prose.textContent = stripPartialRec(fullText);
              } else if (payload.type === 'error') {
                try { reader.cancel(); } catch (cancelErr) { /* swallow */ }
                showError("Our sizing AI is taking a quick breather. Click the chat in the bottom-right corner, click Ask a Question & you will find the size finder there as well...usually less than 2 minutes.");
                submit.disabled = false;
                return;
              } else if (payload.type === 'done' && payload.prompt_version) {
                promptVersion = payload.prompt_version;
              }
            }
          }
          clearSilenceTimer();

          var parsed = parseRecommendation(fullText);
          prose.textContent = parsed.prose;
          recommendation = parsed.recommendation || inferRecommendationFromProse(parsed.prose, variants);

          var integrityMismatch = false;
          if (recommendation) {
            var proseSize = extractBoldedSize(parsed.prose);
            var jsonSize = normalizeSizeName(recommendation.size);
            integrityMismatch = !!(proseSize && jsonSize && proseSize !== jsonSize);
            renderCta(recommendation, variants);
            // Phase B prep (round-7) — store rec_id where the PDP ATC hook expects it
            try { localStorage.setItem('apolla_pending_rec_id', recId); } catch (lsErr) { /* localStorage blocked */ }
          }

          // Fire on every successful completion, not only mismatches, so NULL
          // integrity flags are promoted to a boolean even when the AI agrees.
          reportSizingAiIntegrity(recId, integrityMismatch);
        } catch (err) {
          if (silenceTimer) clearTimeout(silenceTimer);
          var isSilence = silentTimeout || (err && (err.name === 'AbortError' || /aborted/i.test(String(err.message || ''))));
          if (isSilence) {
            showError("Our sizing AI is taking a quick breather. Click the chat in the bottom-right corner, click Ask a Question & you will find the size finder there as well...usually less than 2 minutes.");
          } else {
            showError('Network error. Try again or use the size chart.');
          }
        } finally {
          submit.disabled = false;
        }
      }

      function selectSizeOnPage(sizeLabel) {
        if (!sizeLabel) return false;
        var target = String(sizeLabel).trim().toLowerCase();
        var scope = productScope || document;

        var candidates = Array.prototype.slice.call(scope.querySelectorAll(
          'input[type="radio"][name*="Size" i],' +
          'input[type="radio"][name*="size" i],' +
          'input[type="radio"][name*="option" i]'
        ));

        var match = null;
        for (var i = 0; i < candidates.length; i++) {
          var input = candidates[i];
          if (!input || input.disabled) continue;
          if (input.closest && input.closest('.apolla-sizing-ai')) continue;
          var value = String(input.value || '').trim().toLowerCase();
          if (!value) continue;
          if (value === target) { match = input; break; }
          if (!match && value.replace(/\s+/g, '') === target.replace(/\s+/g, '')) match = input;
        }

        if (!match) {
          var labels = scope.querySelectorAll(
            '.apolla-sizing-ai ~ * label, .product-form label, fieldset label, .variant-input label'
          );
          for (var j = 0; j < labels.length; j++) {
            var lbl = labels[j];
            if (lbl.closest && lbl.closest('.apolla-sizing-ai')) continue;
            var labelText = String(lbl.textContent || '').trim().toLowerCase();
            if (labelText === target) {
              var escapedFor = lbl.htmlFor && window.CSS && window.CSS.escape ? window.CSS.escape(lbl.htmlFor) : lbl.htmlFor;
              var radio = lbl.querySelector('input[type="radio"]') ||
                          (escapedFor && scope.querySelector('#' + escapedFor));
              if (radio && !radio.disabled && !(radio.closest && radio.closest('.apolla-sizing-ai'))) {
                match = radio;
                break;
              }
            }
          }
        }

        if (!match) return false;

        try {
          var savedScrollY = window.scrollY;
          var savedScrollX = window.scrollX;
          match.checked = true;
          match.dispatchEvent(new Event('change', { bubbles: true }));
          match.dispatchEvent(new Event('input', { bubbles: true }));
          var restoreScroll = function () {
            window.scrollTo(savedScrollX, savedScrollY);
          };
          if (typeof requestAnimationFrame === 'function') {
            requestAnimationFrame(function () {
              restoreScroll();
              requestAnimationFrame(restoreScroll);
            });
          } else {
            restoreScroll();
          }
          // Belt-and-suspenders: Shopify variant-change handlers often trigger
          // deferred re-renders (price/inventory) that cause layout shifts AFTER
          // the RAF restore. Re-apply at later checkpoints to catch them.
          setTimeout(restoreScroll, 50);
          setTimeout(restoreScroll, 200);
          setTimeout(restoreScroll, 500);
          setTimeout(restoreScroll, 1000);
          return true;
        } catch (err) {
          return false;
        }
      }

      function renderCta(rec, variants) {
        var primary = variants.filter(function (v) { return v.id === String(rec.variant_id); })[0];
        var alt = rec.alt_variant_id ? variants.filter(function (v) { return v.id === String(rec.alt_variant_id); })[0] : null;
        var chosen = primary && primary.available ? primary : (alt && alt.available ? alt : primary);
        if (!chosen) {
          ctaSlot.innerHTML =
            '<p class="apolla-sizing-ai__answer-cta-label">Your size</p>' +
            '<p class="apolla-sizing-ai__answer-cta-size apolla-sizing-ai__answer-cta-size--warn">Unavailable</p>' +
            '<p class="apolla-sizing-ai__answer-cta-hint apolla-sizing-ai__answer-cta-hint--warn">Try the size chart for alternatives.</p>';
          ctaSlot.removeAttribute('hidden');
          return;
        }
        var available = chosen.available;
        var label = chosen.size || chosen.title;
        var autoSelected = available ? selectSizeOnPage(label) : false;
        // Products with a traction option: Alpha Shock, Performance Shock, AMP Shock, Infinite Shock.
        // All other styles only have color (no traction picker), so omit "and traction" from the hint.
        var TRACTION_HANDLES = ['the-alpha-shock', 'the-performance-shock', 'the-amp-shock', 'the-infinite-shock'];
        var productHandle = (root.dataset.productHandle || '').toLowerCase();
        var hasTraction = TRACTION_HANDLES.indexOf(productHandle) !== -1;
        var confirmText = hasTraction ? 'Confirm your color and traction' : 'Confirm your color';
        var selectConfirmText = hasTraction ? 'confirm your color and traction' : 'confirm your color';
        var hintHtml;
        if (!available) {
          hintHtml = '<p class="apolla-sizing-ai__answer-cta-hint apolla-sizing-ai__answer-cta-hint--warn">' + escapeHtml(label) + ' is currently out of stock. Try the size chart for alternatives.</p>';
        } else if (autoSelected) {
          hintHtml = '<p class="apolla-sizing-ai__answer-cta-hint">We’ve selected <strong>' + escapeHtml(label) + '</strong> above for you. ' + confirmText + ', then click <strong>Add to Cart</strong>.</p>';
        } else {
          hintHtml = '<p class="apolla-sizing-ai__answer-cta-hint">Select <strong>' + escapeHtml(label) + '</strong> above, ' + selectConfirmText + ', then click <strong>Add to Cart</strong>.</p>';
        }
        ctaSlot.innerHTML =
          '<p class="apolla-sizing-ai__answer-cta-label">Your size</p>' +
          '<p class="apolla-sizing-ai__answer-cta-size">' + escapeHtml(label) + '</p>' +
          hintHtml;
        ctaSlot.removeAttribute('hidden');
      }

      trigger.addEventListener('click', function () {
        var isOpen = trigger.getAttribute('aria-expanded') === 'true';
        togglePanel(!isOpen);
        if (!isOpen) showState('form');
      });

      form.addEventListener('submit', submitForm);

      restart.addEventListener('click', function () {
        resetForm();
      });

      errorBox.addEventListener('click', function (e) {
        if (e.target.classList && e.target.classList.contains('apolla-sizing-ai__error-fallback')) return;
      });
    }

    window.ApollaSizingAI = window.ApollaSizingAI || {};
    window.ApollaSizingAI.init = function (container) {
      (container || document).querySelectorAll('.apolla-sizing-ai').forEach(init);
    };
    window.ApollaSizingAI.init(document);
  })();
  } catch(e) { console.error(e); }
})();

})();
